module.exports = __webpack_public_path__ + "img/cancel-icon.b2b319ed.svg";